module.exports = __webpack_public_path__ + "static/img/nav2.7f1bcc1c.svg";